module.exports = __webpack_public_path__ + "img/07.b63fc2e6.png";